import React from 'react';
import { Modal,Button } from "antd-mobile"
import util from "../../util/tools";
// import Toast from '../common/Toast'
import { Toast } from 'antd-mobile';
import "./index.css"

export default class ActiveCore extends React.Component {
    //活动核心部分
    constructor(props) {
        super(props);
        let defaultRule = this.props.activeId === 1 ?
            {
                label:"8888金币，畅读本站小说",
                max:99,
            } :
            {
                label:"18888金币，金币拿到手软，看书看到爽飞~",
                max:208,
            }
            //不同活动最大参与次数不同，接口参数不同
        this.state = {
            ...defaultRule,
            modal1:false,
            modal2:false,
            reduceCancel:true,
            value:100, // 初始投入金币
            timer:1, //初始兑换码个数
            step:100, //步长
            tickStep:1,//每100金币对应的兑换码个数，目前是1
            onceMaxLimit:99999999, //单次投注限额，暂无
            userInfo:{},
            text:"",
            tickets:[],
        };
    }

    componentDidMount() {
        // this.getUserInfo()
    }

    modalOpen = () => {
        this.props.modalOpen()
    }

    modalClose = () => {
        this.props.modalClose()
    }

    jumpToPay = () => {
        this.props.jumpToPay()
    }

    JoinToReport = () => {
        this.props.JoinToReport()
    }

    getActiveData = () => {
        this.props.getActiveData()
    }

    onClose = (label) => {
        console.log(111)
        this.changeModalVisible(undefined,label)
    }

    activeInit = () => {
        this.setState({
            reduceCancel:true,
            value:100,
            timer:1,
        })
    }

    changeModalVisible = (val,label) => {
        if(val===true && label==="modal1"){
            this.activeInit()
        }
        let fixValue = val !== undefined ? val : !this.state[label]
        if(fixValue){
            this.modalOpen()
        }else{
            this.modalClose()
        }
        this.setState({
            [label]:fixValue
        },)
    }

    reduceCoin = () => {
        if(this.state.value - this.state.step <= 0){
            //最小金额不允许再减少了
            this.showMsg("参与活动不能小于100金币")
            return
        }else{
            this.setState({
                value:this.state.value - this.state.step,
                timer:this.state.timer - this.state.tickStep
            },()=>{
                if(this.state.value<=100){
                    this.setState({
                        reduceCancel:true
                    })
                }
            })
        }
    }

    addCoin = () => {
        if(this.state.value + this.state.step >= this.state.onceMaxLimit){
            //最大金额不允许再增加了
            this.showMsg(`参与活动不能大于${this.state.onceMaxLimit}金币`)
            return
        }else{
            this.setState({
                reduceCancel:false,
                value:this.state.value + this.state.step,
                timer:this.state.timer + this.state.tickStep
            })
        }
    }

    getUserInfo = () => {
        this.props.getUserInfo()
    }

    sureToPayCoin = () => {
        let activeId = this.props.activeId // 活动id
        let coin = this.state.value
        let userCoin = parseInt(this.props.userInfo && this.props.userInfo.user_money && this.props.userInfo.user_money.coin || 0)
        if(userCoin >= coin){
            util.ajax({
                url: "/zh/treasure/partake",
                isUser: true,
                isWechatId: true,
                method:'post',
                data: {
                    coin:coin,
                    code_type:activeId,
                },
                callback: res => {
                    if (res && res.result.status.code == 0) {
                        this.paySuccess(res.result.data)
                    }else{
                        this.showMsg(res.result.status.msg)
                    }
                    //无论成功失败，都获取一次活动信息，避免因为参与人数超出用户不知道的情况
                    //避免用户金币在其他地方消费 而导致显示不同步引起的问题
                    this.getActiveData()
                    this.getUserInfo()
                }
            })

            // 弹框提示成功 刷新活动进程 刷新用户金币
        }else{
            this.showMsg("金币不足,2s后跳转充值")
            setTimeout(()=>{
                this.jumpToPay()
            },2000)
        }
    }

    paySuccess = (data) => {
        this.setState({
            tickets:data || []
        },()=>{
            this.changeModalVisible(false,"modal1")
            setTimeout(()=>{
                this.changeModalVisible(true,"modal2")
            },500)
        })
    }

    showMsg = (val) => {
        Toast.info(val,2)
        // this.setState({
        //     text:val
        // })
        // setTimeout(()=>{
        //     this.setState({
        //         text:""
        //     })
        // },2000)
    }

    render() {
        let total = ~~(this.props.activeData.partake_total_num)
        let lost = ~~(this.props.activeData.surplus_num)
        let joined = total - lost
        let leftLength = joined/total * 100 === NaN ? 0 : joined/total * 100
        let rightLength = lost/total * 100 === NaN ? 0 : lost/total * 100
        let activeData = this.props.activeData
        let userCoin = this.props.userInfo && this.props.userInfo.user_money && this.props.userInfo.user_money.coin || 0
        return (
            <div className="active-core" style={{...this.props.style,width:"5.85rem",height:"3.17rem",margin:"0 auto",position:"relative"}}>
                <div>
                    {
                        this.props.activeId === 1 ?
                            <img style={{display:"inline-block",width:"100%",height:"100%"}} src={require('../../../common/images/yuandanCore3.png')}/> :
                            <img style={{display:"inline-block",width:"100%",height:"100%"}} src={require('../../../common/images/yuandanCore2.png')}/>
                    }
                    <div className="active-label-wrapper">
                        <div className="active-normal">{this.state.label}</div>
                        <div className="line-wrapper">
                            <span className="line-1" style={{visibility:`${leftLength===0 ?"hidden":"initial"}`,width:`${leftLength>0.4?leftLength:(leftLength===0 ? 0 :2) }%`}}></span>
                            <span className="line-2" style={{width:`${leftLength>0.4?rightLength:(leftLength===0 ? 100 :98)}%`}}></span>
                        </div>
                        <div>
                        <span>
                            <span className="active-normal">
                                总需
                            </span>
                            <span className="active-red">
                                {this.state.max}
                            </span>
                            <span className="active-normal">
                                参与次
                            </span>
                        </span>

                        <span style={{float:"right"}}>
                            <span className="active-normal">
                                距离开奖还差
                            </span>
                            <span className="active-red">
                                {activeData && activeData.surplus_num || 0}
                            </span>
                            <span className="active-normal">
                                参与次
                            </span>
                        </span>
                        </div>
                    </div>
                </div>
                <div style={{marginTop:this.props.activeId === 1 ? "0.45rem": "0.1rem"}} onClick={()=>{
                    this.changeModalVisible(true,"modal1");
                    this.JoinToReport();
                }}>
                    <img style={{display:"inline-block",width:"100%",height:"100%"}} src={require('../../../common/images/yuandanCore1.png')}/>
                </div>
                <Modal
                    style={{
                        width:"6.7rem",
                    }}
                    visible={this.state.modal1}
                    transparent
                    maskClosable={true}
                    onClose={()=>this.onClose('modal1')}
                >
                    <div className="active-user-normal-close">
                        <div style={{textAlign:"right"}}>
                            <img style={{position:"relative",right:"0.1rem",top:"0.1rem",width:"0.44rem",height:"0.44rem"}}
                                 src={require("../../../common/images/close.png")}
                                 onClick={()=>this.onClose('modal1')}
                            />
                        </div>
                    </div>
                    <div className="active-user-normal" style={{ height: 300, overflow: 'scroll'}}>
                        <div style={{marginTop:"0.3rem"}}>
                            <span>您当前用户余额：</span>
                            <span className="active-user-ticket">{userCoin}</span>
                            <span>金币</span>
                        </div>
                        <div style={{marginTop:"0.7rem"}}>
                            <span>投入金币：</span>
                            <span>
                                <span className="active-click-handle"
                                      style={{background:this.state.reduceCancel ? "#dddddd" : "#fff" }} onClick={this.reduceCoin}>-</span>
                                <span className="active-click-coin">{this.state.value}</span>
                                <span className="active-click-handle" onClick={this.addCoin}>+</span>
                            </span>
                        </div>
                        <div style={{marginTop:"0.6rem"}}>
                            <span className="active-click-des">
                                <span>可获得</span>
                                <span className="active-click-des-red">{this.state.timer}</span>
                                <span>个兑换码</span>
                            </span>
                        </div>
                        <div className="active-sure" onClick={()=>this.sureToPayCoin()}>确定</div>
                    </div>
                </Modal>

                <Modal
                    className="core-modal"
                    style={{
                        width:"6.7rem",position:"relative"
                    }}
                    visible={this.state.modal2}
                    transparent
                    maskClosable={true}
                    onClose={()=>this.onClose('modal2')}
                >
                    <div style={{width:"6.7rem",height:"0.2rem",position:"absolute",left:"0px",
                    top:"-0.57rem",zIndex:"999997"}}>
                        {/*<div className="modal2-top"></div>*/}
                        <img style={{display:"inline-block",width:"6.7rem"}} src={require("../../../common/images/top_bg.png")}
                        />
                    </div>
                    <div className="active-user-normal-close">
                        <div style={{textAlign:"right"}}>
                            <img style={{width:"0.44rem",height:"0.44rem"}}
                                 src={require("../../../common/images/close.png")}
                                 onClick={()=>this.onClose('modal2')}
                            />
                        </div>
                    </div>
                    <div className="active-user-normal" style={{ height: 250, overflow: 'scroll',textAlign:"center"}}>
                        <div style={{marginTop:"0.3rem"}}>
                            <span>恭喜您获得</span>
                            <span className="active-user-ticket">
                                {(this.state.tickets || []).length}
                            </span>
                            <span>个兑换码</span>
                        </div>
                        <div style={{marginTop:"0.6rem"}}>
                            {
                                this.state.tickets.map(i=>{
                                    return <div>{i}</div>
                                })
                            }
                        </div>
                        <div style={{marginTop:"0.5rem"}}>
                            <span className="active-click-des" style={{textAlign:"center"}}>
                               您可在【我的夺宝结果】中查看兑换码和中奖信息
                            </span>
                        </div>
                    </div>
                    <div onClick={()=>this.onClose('modal2')} className="active-sure" style={{margin:"0 auto"}}>确定</div>
                </Modal>

                {/*<Toast text={this.state.text}/>*/}
            </div>
        );
    }
}